import React, { Fragment } from "react";
import PropTypes from "prop-types";

import MobileProjectPage from "components/Project/MobileProjectPage";

import Slider from "react-slick";

const propTypes = {
  topics: PropTypes.array.isRequired,
  more: PropTypes.bool,
  renderProjectPanel: PropTypes.func,
  renderProjectUserPanel: PropTypes.func,
  renderTopics: PropTypes.func,
  handleMore: PropTypes.func
};

class CustomMobileProjectPage extends MobileProjectPage {
  /* Custom: simplified version */
  renderSlider() {
    const settings = {
      dots: true,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      speed: 100,
      swipeToSlide: true,
      centerMode: false,
      centerPadding: "30px",
      className: "custom-topic-card-slider",
      initialSlide: this.setMobileProjectInitialSlide(),
      beforeChange: (oldIndex, newIndex) => {
        if (this.props.more && newIndex === this.props.topics.length - 1) {
          this.props.handleMore();
        }
      }
    };

    /* isMobile is true */
    let sliderCards = this.props.renderTopics(this.props.topics, true);

    return (
      <Slider ref="slider" {...settings}>
        {sliderCards}
      </Slider>
    );
  }

  render() {
    return (
      <Fragment>
        <div className="bottommargin">
          {this.props.renderProjectUserPanel()}
        </div>
        <div>{this.props.renderProjectPanel()}</div>
        <div className="bottompadding-30">{this.renderSlider()}</div>
      </Fragment>
    );
  }
}

CustomMobileProjectPage.propTypes = propTypes;

export default CustomMobileProjectPage;
